import { TimeRangeTypes } from "@enums/time-range-types";
import {
    WorkflowReportCompletionRateDataType,
    WorkflowReportCompletionRatesOverTimeResponse,
    WorkflowReportFraudResponse,
    WorkflowReportPassRateDataType,
    WorkflowReportPassRatesOverTimeResponse,
    WorkflowReportRpServiceConfiguration,
    WorkflowReportStepByStepResponse,
    WorkflowReportVolumesByAppIdResponse,
    WorkflowReportVolumesByCountryResponse
} from "../data/reports";

export type WorkflowReportSearchFiltersState = {
    workflowId: string;
    appId: string;
    country: string;
    timeRangeType: TimeRangeTypes;
    startDate: Date;
    endDate: Date;
    includeArchivedWorkflows: boolean;
};

export enum WorkflowReportSearchResultsTypes {
    passRatesAndPassRateOverTime =  "passRatesAndPassRateOverTime",
    completionRates = "completionRates",
    completionRatesOverTime = "completionRatesOverTime",
    stepByStep = "stepByStep",
    fraud="fraud",
    volumesByAppID = "volumesByAppID",
    volumesByCountry = "volumesByCountry"
}

export type WorkflowReportSearchResults = {
    passRates: WorkflowReportPassRateDataType;
    passRatesOverTime: WorkflowReportPassRatesOverTimeResponse;
    completionRates: WorkflowReportCompletionRateDataType;
    completionRatesOverTime: WorkflowReportCompletionRatesOverTimeResponse;
    stepByStep: WorkflowReportStepByStepResponse;
    fraud: WorkflowReportFraudResponse;
    volumesByAppID: WorkflowReportVolumesByAppIdResponse;
    volumesByCountry: WorkflowReportVolumesByCountryResponse;
};

export type WorkflowReportSearchResultsState = WorkflowReportSearchResults & {
    searchDate: Date;
    isLoading: {
        [key in WorkflowReportSearchResultsTypes]: boolean;
    };
};

export type WorkflowReportMetadataSearchResults = {
    appIDs: Array<string>;
    countries: Array<string>;
    rpServices: Array<WorkflowReportRpServiceConfiguration>;
};

export type WorkflowReportMetadataSearchResultsState = WorkflowReportMetadataSearchResults & {
    searchDate: Date;
    isLoading: boolean;
};

export type WorkflowReportMetadataSearchFilters = {
    workflowId: string;
    startDate: Date;
    endDate: Date;
};

export type WorkflowReportState = {
    searchFilters: WorkflowReportSearchFiltersState;
    searchResults: WorkflowReportSearchResultsState;
    metadataSearchResults: WorkflowReportMetadataSearchResultsState;
    metadataSearchFilters: WorkflowReportMetadataSearchFilters;
    searchedMetadataSearchResults: WorkflowReportMetadataSearchResults;
};